/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { useState } from "react";
import EmailGroups from "../../../components/Administrations/Emails/EmailGroups/EmailGroups";
import SmtpEmail from "../../../components/Administrations/Emails/SmtpEmail/Smtp";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs";

const Emails: React.FC = () => {
  const tabs = [
    { label: "Email Groups", value: "email-groups", component: <EmailGroups /> },
    { label: "SMTP", value: "smtp", component: <SmtpEmail /> },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].value);

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab}>
      <div className="pl-4 pr-1 mt-4">
        <div style={{ borderBottom: "1px solid var(--color-border)" }}>
          <TabsList className="inline-flex h-auto gap-0 rounded-none border-0 bg-transparent p-0 text-muted-foreground shrink-0">
            {tabs.map((tab) => (
              <TabsTrigger
                key={tab.value}
                value={tab.value}
                className="rounded-none border-b-2 border-transparent bg-transparent px-4 py-2 text-sm capitalize text-muted-foreground data-[state=active]:border-primary data-[state=active]:text-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none"
              >
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
      </div>
      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="pt-4">
          {tab.component}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default Emails;